// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e638b54","455":"12c995f5","977":"af57b335"}[chunkId] + ".chunk.js";
};